import { editNavKey } from './edit-nav-key';

export const tabList = [
    { value: editNavKey.ADMIN, name: 'Admin' },
    { value: editNavKey.GENERAL, name: 'Recipient Data' },
    { value: editNavKey.CONTACT_INFORMATION, name: 'Recipient Address' },
    { value: editNavKey.MEDICAL_DETAILS, name: 'Medical Details' },
    { value: editNavKey.HLA_INFORMATION, name: 'HLA Info' },
    { value: editNavKey.RECORDS, name: 'Records' },
    { value: editNavKey.FINANCIAL_INFORMATION, name: 'Financial Info' },
    { value: editNavKey.ACTIVITY_LOG, name: 'XM/Activity Logs' },
    { value: editNavKey.DONOR_DECLINES, name: 'Donor Declines' },
    { value: editNavKey.POST_TRANSPLANT, name: 'Post Transplant' },
];
